export default __webpack_public_path__ + "static/media/Google_Certs_IT.fa80b656.png";